import { mergeStyles, Stack, Text } from '@fluentui/react';

import { useAppSelector } from '../../../App/store';
import EmployeeAvgSalesValue from './data-components/EmployeeAvgSalesValue';
import EmployeeSalesByRetail from './data-components/EmployeeSalesByRetail';
import EmployeeValuesByRetail from './data-components/EmployeeValuesByRetail';
import RetailAvgSalesValue from './data-components/RetailAvgSalesValue';
import TotalRetailSales from './data-components/TotalRetailSales';
import TotalRetailSalesCount from './data-components/TotalRetailSalesCount';

export default () => {
  const isAdmin = useAppSelector(
    (state) => state.auth.userdata?.admin === true
  );

  if (!isAdmin) {
    return <>Unauthorized</>;
  }

  return (
    <div className={containerStyles}>
      <Text variant="xxLarge">Analitikler</Text>
      <br />
      <br />
      <Stack wrap horizontal tokens={{ childrenGap: 15 }}>
        <EmployeeValuesByRetail />
        <EmployeeSalesByRetail />
        <TotalRetailSales />
        <TotalRetailSalesCount />
        <EmployeeAvgSalesValue />
        <RetailAvgSalesValue />
      </Stack>
    </div>
  );
};

const containerStyles = mergeStyles({
  padding: "16px 28px",
});
